import client from "../api/client/SdsWebApiClient";
import { IntroConfig, Preset } from "../models/IntroConfig";
import { getModelFromConfig } from "./dataUtils";
import isDev from "./environmentUtils";

export function goToConfigurator(configString: string, configEncoding?: string, surfaceProductArticleNo?: string) {
    const configuratorUrl = isDev() ? "http://localhost:3007/" : "../configurator/";

    // Forward all URL parameters to the configurator except
    // for some specially handled parameters.
    const searchParams = new URLSearchParams(window.location.search);
    searchParams.delete("enc_type");
    if (configEncoding) {
        searchParams.append("enc_type", configEncoding);
    }

    if (surfaceProductArticleNo) {
        searchParams.append("surface_product", surfaceProductArticleNo);
    }

    // Add the site_url from the parent page if not specified,
    // but only when embedded in an iframe.
    if (window.self !== window.top && !searchParams.get("site_url") && document.referrer) {
        const referrer = new URL(document.referrer);
        referrer.hash = "";
        referrer.search = "";
        searchParams.set("site_url", referrer.href);
    }

    // Add the config_string parameter manually to avoid URL encoding it,
    // just so it can be copied directly from the URL.
    searchParams.delete("config_string");
    let queryParams = searchParams.toString();
    if (queryParams) queryParams += "&";
    queryParams += `config_string=${configString}`;

    window.location.assign(`${configuratorUrl}?${queryParams}`);
}

export async function activateArticleNumber(
    articleNo: string,
    introConfig: IntroConfig,
    accountId: string | undefined,
    setFilter: string[] | undefined
): Promise<boolean> {
    return new Promise(resolve => {
        client.findMenuPathsByArticleNoGet(articleNo, accountId, true, setFilter).then(
            paths => {
                if (paths.length === 0) {
                    // eslint-disable-next-line no-console
                    console.log(`Article not found: ${articleNo}`);
                    return;
                }

                const models = new Set(paths.map(p => p.model));
                const set = findFirstSetByModel(introConfig.sets, models);
                if (set) {
                    goToConfigurator(set.config, undefined, articleNo);
                    resolve(true);
                } else {
                    resolve(false);
                }
            },
            () => resolve(false)
        );
    });
}

function findFirstSetByModel(sets: Preset[], models: Set<string>): Preset | null {
    for (const set of sets) {
        const configModel = getModelFromConfig(set.config);
        if (models.has(configModel)) {
            return set;
        }
    }

    for (const set of sets) {
        if (set.sets) {
            const childSet = findFirstSetByModel(set.sets, models);
            if (childSet) {
                return childSet;
            }
        }
    }

    return null;
}

export function makeUrlLowerCase(url: URL) {
    url.pathname = url.pathname.toLowerCase();
    url.hostname = url.hostname.toLowerCase();
    url.protocol = url.protocol.toLowerCase();
}
